/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-read-only-property';


// MAIN //

/**
* Top-level namespace.
*
* @namespace erlang
*/
var erlang = {};

/**
* @name cdf
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/cdf}
*/
import cdf from './../../../../base/dists/erlang/cdf';
setReadOnly( erlang, 'cdf', cdf );

/**
* @name Erlang
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/ctor}
*/
import Erlang from './../../../../base/dists/erlang/ctor';
setReadOnly( erlang, 'Erlang', Erlang );

/**
* @name entropy
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/entropy}
*/
import entropy from './../../../../base/dists/erlang/entropy';
setReadOnly( erlang, 'entropy', entropy );

/**
* @name kurtosis
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/kurtosis}
*/
import kurtosis from './../../../../base/dists/erlang/kurtosis';
setReadOnly( erlang, 'kurtosis', kurtosis );

/**
* @name logpdf
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/logpdf}
*/
import logpdf from './../../../../base/dists/erlang/logpdf';
setReadOnly( erlang, 'logpdf', logpdf );

/**
* @name mean
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/mean}
*/
import mean from './../../../../base/dists/erlang/mean';
setReadOnly( erlang, 'mean', mean );

/**
* @name mgf
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/mgf}
*/
import mgf from './../../../../base/dists/erlang/mgf';
setReadOnly( erlang, 'mgf', mgf );

/**
* @name mode
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/mode}
*/
import mode from './../../../../base/dists/erlang/mode';
setReadOnly( erlang, 'mode', mode );

/**
* @name pdf
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/pdf}
*/
import pdf from './../../../../base/dists/erlang/pdf';
setReadOnly( erlang, 'pdf', pdf );

/**
* @name quantile
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/quantile}
*/
import quantile from './../../../../base/dists/erlang/quantile';
setReadOnly( erlang, 'quantile', quantile );

/**
* @name skewness
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/skewness}
*/
import skewness from './../../../../base/dists/erlang/skewness';
setReadOnly( erlang, 'skewness', skewness );

/**
* @name stdev
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/stdev}
*/
import stdev from './../../../../base/dists/erlang/stdev';
setReadOnly( erlang, 'stdev', stdev );

/**
* @name variance
* @memberof erlang
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/erlang/variance}
*/
import variance from './../../../../base/dists/erlang/variance';
setReadOnly( erlang, 'variance', variance );


// EXPORTS //

export default erlang;
